import { fetchAllContactFlags } from 'legacy/lut/services/contacts/contactFlags'

import { IContact } from 'clickNgo/entities/contact'
import { emptyContactFlags, IContactFlag, IContactFlags } from 'clickNgo/entities/contactFlag'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { Nullable } from 'clickNgo/models/utils'

export const getContactFlags = async (contact: IContact): Promise<Nullable<IContactFlags>> => {
  const options: ICrudFetchOptions = {
    cacheKey: contact?.contactId,
    sort: {
      field: 'Modified',
      dir: 'desc',
    },
    paging: {
      page: 0,
      pageSize: 1000,
    },
  }

  const data = await fetchAllContactFlags(
    {
      contactId: contact.contactId,
      partnerId: contact.partnerId,
    },
    options
  )

  if (!data) {
    return null
  }

  const contactFlags = data.reduce((acc: IContactFlags, flag: IContactFlag) => {
    acc[flag.type].push(flag)

    return acc
  }, emptyContactFlags)

  return contactFlags
}
